
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48 15.702c0 3.431-2.762 6.213-6.17 6.213-3.406 0-6.168-2.782-6.168-6.213 0-3.43 2.762-6.212 6.169-6.212 3.407 0 6.169 2.78 6.169 6.212M34.96 5.598c0 3.092-2.489 5.599-5.56 5.599-3.07 0-5.559-2.507-5.559-5.599S26.331 0 29.401 0c3.07 0 5.559 2.506 5.559 5.598m-18.293 1.26c0 2.48-1.996 4.49-4.459 4.49-2.462 0-4.459-2.01-4.459-4.49 0-2.48 1.997-4.49 4.459-4.49 2.463 0 4.459 2.01 4.459 4.49m-9.826 14.2c0 1.903-1.531 3.445-3.42 3.445C1.53 24.503 0 22.96 0 21.059c0-1.903 1.531-3.445 3.42-3.445 1.89 0 3.421 1.542 3.421 3.445m1.074 16.35a2.819 2.819 0 01-2.808 2.83 2.819 2.819 0 01-2.81-2.83 2.82 2.82 0 012.81-2.828 2.819 2.819 0 012.808 2.829m12.982 10.316A2.266 2.266 0 0118.64 50a2.266 2.266 0 01-2.258-2.274 2.266 2.266 0 012.258-2.275 2.266 2.266 0 012.258 2.275m16.376-.482a1.809 1.809 0 01-1.802 1.815 1.809 1.809 0 01-1.803-1.815c0-1.002.808-1.814 1.803-1.814.995 0 1.802.812 1.802 1.814M45.4 32.902c0 .725-.585 1.313-1.305 1.313s-1.304-.588-1.304-1.313c0-.726.584-1.314 1.304-1.314.72 0 1.305.588 1.305 1.314","fill":"#4FDCA7"}})])
          )
        }
      }
    